module.exports = __webpack_public_path__ + "img/shield.32d32e4b.svg";